export function isSelectOptionEmpty(
  value: unknown,
  fieldName: string,
): boolean {
  if (value == null || value === '') {
    return true;
  }

  if (typeof value === 'object') {
    const option = value as Record<string, unknown>;
    const id = option.id;
    const fieldValue = option[fieldName];

    return (
      (id == null || id === '') && (fieldValue == null || fieldValue === '')
    );
  }

  return false;
}

export function getSelectOptionLabel(
  value: unknown,
  fieldName: string,
): string {
  if (isSelectOptionEmpty(value, fieldName)) {
    return '';
  }

  if (typeof value === 'object' && value !== null && fieldName in value) {
    const raw = (value as Record<string, unknown>)[fieldName];
    return raw == null ? '' : String(raw);
  }

  return String(value ?? '');
}
